<mat-form-field appearance="outline">
  
  @if (showLabel) {
  <mat-label>{{ label }}</mat-label>
  }
  <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a date" [formControl]="dateControl"
    [min]="minDate" [max]="maxDate" (dateChange)="startDateChange($event)" [placeholder]="showPlaceholder ? ('dashboard.start_date' | translate) : ''">

  <lib-button matSuffix (click)="picker.open()" color="none" size="small" icon="today">
  </lib-button>

  <ngx-mat-datetime-picker #picker [showSpinners]="true" [showSeconds]="showSeconds" [stepHour]="stepHour"
    [stepMinute]="stepMinute" [stepSecond]="stepSecond" [touchUi]="touchUi" [color]="color"
    [enableMeridian]="enableMeridian" [disableMinute]="disableMinute" [hideTime]="hideTime">
  </ngx-mat-datetime-picker>
</mat-form-field>